<template>
    <div>
<!--        <div class="row">-->
<!--            <div class="col-12" v-if="!!quote_external_id">-->
<!--                <div>-->

<!--                    <router-link :to="{path: url}" tag="a" class="btn btn-default">{{lang('continue_with_old_application')}}</router-link>-->
<!--                    <router-link :to="{path: '/application/add/business'}" tag="a" class="btn btn-default">{{lang('start_new_application')}}</router-link>-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="col-12" v-else>-->
<!--                <router-link :to="{path: '/application/add/business'}" tag="a" class="btn btn-default">{{lang('start_new_application')}}</router-link>-->
<!--            </div>-->

<!--        </div>-->

    </div>

</template>

<script>
import applicationMixin from "../../utils/application-mixin";
import NPAppBreadcrumb from "../../components/np-application-breadcrumb.vue";
import {NPSkeleton} from "netpify/components";
import * as types from "../../stores/constants";
import EventBus from "../../utils/event_bus";

export default {
    name: "ApplyNow",
    data() {
        return {
            has_quote: false,
            quote_external_id: '',
            url: '',
            application: [],
        }
    },
    created() {
        let vm = this;
        let quote_external_id = !!vue_data && vue_data.hasOwnProperty('quote_external_id') ? vue_data.quote_external_id : false;

        if (!quote_external_id) {
            this.$router.push({path: '/application/add/business'})
        } else {
            this.quote_external_id = quote_external_id;
            this.url = `/quote/edit/${this.quote_external_id}/business`
            this.$router.push({path: this.url})
        }
    },
    computed: {},
    methods: {},
    watch: {}
}
</script>

<style scoped>

</style>